import React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "types/store";
import styles from "./style.module.css";
import { Button } from "aible";

import FoldersCreateContainer from "containers/Folders/FoldersCreate";
import Tooltip from "components/Inputs/Tooltip";

import * as chatGPTReducer from "containers/ChatGPT/reducer";
import { getSelectedFolderData } from "containers/Folders/reducer";

import CircularProgressBar from "aible/CircularProgressBar/CircularProgressBar";
import UsersGrayIcon from "images/users-gray.svg";
import { isEnabled } from "utils/featureFlags";

const AddCollaboratorButton = ({ className, id, ...retProps } = {}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(chatGPTReducer.fetchConversationFeedbackUsers(id));
  }, [id]);

  const [showModal, updateShowModal] = useState(false);

  const selectedFolder = useSelector((state) => getSelectedFolderData(state));

  const folderUsers = selectedFolder?.roles;
  const folderUsersCount = folderUsers?.length ?? 0;

  const addedFeedbackUsers = useSelector((state) => chatGPTReducer.getConversationFeedbackUsers(state, id));

  const addedFeedbackUsersCount = addedFeedbackUsers?.length ?? 0;

  if (isEnabled("hide-sharing")) {
    return null;
  }

  return (
    <React.Fragment>
      <Tooltip trigger={["hover"]} overlay={"Add Collaborators"}>
        <Button
          style={{ marginRight: "10px", padding: "4px 16px" }}
          onClick={(e) => updateShowModal(!showModal)}
          className={styles.addCollaboratorButton + " " + (className ? className : "")}
          {...retProps}
          greyscaleDefaultState
        >
          <div className={styles.addCollaboratorButtonWrapper}>
            <div className={styles.addCollaboratorIconWrappper}>
              <CircularProgressBar
                size={28}
                strokeWidth={2}
                progress={folderUsersCount > 0 ? Math.min((addedFeedbackUsersCount / folderUsersCount) * 100, 100) : 0}
                icon={UsersGrayIcon}
                iconScale={1.2}
                iconWidth={16}
                iconHeight={16}
                iconX={6.25}
                iconY={6.5}
              />
            </div>
            <div className={styles.addCollaboratorInfoContainer}>
              <div className={styles.addCollaboratorTitle}>{"Share"}</div>
              <div className={styles.addCollaboratorSubtext}>
                {`${addedFeedbackUsersCount} ADDED FEEDBACK / ${folderUsersCount} INVITED`}
              </div>
            </div>
          </div>
        </Button>
      </Tooltip>
      <FoldersCreateContainer
        showModal={showModal}
        isEdit={false}
        isManagePermissions={true}
        id={selectedFolder?.id}
        handleHide={() => updateShowModal(false)}
        allowSelectUser={false}
      />
    </React.Fragment>
  );
};

export default AddCollaboratorButton;
